<template>
  <section class="buyer-payment-method">
    <b-field label="Forma de Cobrança Contratada">
      <div class="payment-card">
        <b-icon icon="credit-card" size="is-medium" class="icon-style" />
        <span class="payment-label">
          {{ paymentMethodLabel }}
        </span>
      </div>
    </b-field>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { BILLING_STATUS, BILLING_TYPE } from '@/utils/enumerados';

export default {
  name: 'BuyerPaymentMethod',
  props: {
    paymentMethod: {
      type: String,
      default: 'CREDITS',
    },
  },
  computed: {
    ...mapState('companyBilling', [
      'status',
      'description',
      'type',
      'finishDate',
      'startDate',
      'companyCredits',
    ]),
    paymentMethodLabel() {
      const capitalize = text => {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1);
      };

      const formatDate = dateStr => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      };

      if (this.status === BILLING_STATUS.AGUARDANDO) {
        return `Aguardando pagamento - Pendente desde: ${formatDate(this.startDate)}`;
      }

      switch (this.type) {
        case BILLING_TYPE.MONTHLY:
          return `Plano ${capitalize(this.description)} - Finalizando em: ${formatDate(
            this.finishDate,
          )}`;
        case BILLING_TYPE.AVULSA:
          return `Créditos Avulsos - Quantidade atual: ${this.companyCredits}`;
        case BILLING_TYPE.PERCENTUAL:
          return 'Plano Vitalício';
        default:
          return 'Nenhuma forma de cobrança contratada';
      }
    },
  },
  methods: {
    ...mapActions('companyBilling', ['getCompanyCredits', 'getCompanyCurrentBillingMethod']),
  },
  async created() {
    await Promise.all([
      this.getCompanyCurrentBillingMethod(this.$route.params.id),
      this.getCompanyCredits(this.$route.params.id),
    ]);
  },
};
</script>

<style scoped>
.buyer-payment-method {
  margin-top: 10px;
}

.payment-card {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.icon-style {
  color: #3273dc; /* Azul Bulma */
  margin-right: 10px;
}

.payment-label {
  font-size: 16px;
  font-weight: 600;
  color: #363636;
}
</style>
